import { render, staticRenderFns } from "./VDialogConfirm.vue?vue&type=template&id=7623b85f&scoped=true"
import script from "./VDialogConfirm.vue?vue&type=script&lang=js"
export * from "./VDialogConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623b85f",
  null
  
)

export default component.exports